import {
  Breadcrumbs,
  Button,
  Grid,
  IconButton,
  Link,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useState } from "react";
import { CompanyStore } from "store";
import useValidations from "../../hooks/useValidations";
import { LoadingLayer } from "../Importation/Layers";

const useStyles = makeStyles((theme) => ({
  createBox: {
    height: "100%",
    flexGrow: 2,
    backgroundColor: "#f1f1f1",
    position: "absolute",
    zIndex: 10,
    top: "70px",
    left: "0px",
  },
  top: {
    backgroundColor: theme.palette.white,
    height: "50px",
    padding: "15px",
  },
  form: {
    padding: "25px 15px",
    width: "100%",
    textAlign: "center",
  },
  btnRegister: {
    margin: "40px 15px 15px",
  },
  btnClose: {
    position: "absolute",
    right: "50px",
    top: "50px",
    transform: "rotate(45deg)",
  },
}));

const CreateEmployees = ({ onClose }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [inputName, setInputName] = useState<string>("");
  const [inputCpf, setInputCpf] = useState<string>("");
  const [inputEmail, setInputEmail] = useState<string>("");

  const { validated, validateFields } = useValidations({
    name: { required: true },
    cpf: {
      required: true,
      onlyNumbers: true,
      length: { equal: 11 },
      cpf: true,
    },
    email: { required: true, email: true },
  });

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value || undefined;
    if (name === "name") {
      setInputName(value);
    }
    if (name === "cpf") {
      setInputCpf(value);
    }
    if (name === "email") {
      setInputEmail(value);
    }
  };

  const submitForm = (event) => {
    const dataToValidate = {
      name: inputName,
      cpf: inputCpf,
      email: inputEmail,
    };
    if (!validateFields(dataToValidate, true)) return;

    setLoading(true);
    CompanyStore.createCompanysUser(inputName, inputEmail, inputCpf)
      .then(() => {
        setInputName("");
        setInputCpf("");
        setInputEmail("");

        setTimeout(() => {
          onClose();
        }, 1000);
      })
      .finally(() => setLoading(false));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    validateFields({ [name]: value });
  };

  return (
    <>
      {loading && (
        <Grid
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
          style={{
            zIndex: 999,
            width: "100vw",
            height: "86vh",
            background: "rgba(255,255,255,.7)",
            marginTop: "-16px",
          }}
        >
          <LoadingLayer message={""} />
        </Grid>
      )}
      <Grid
        container
        xs={12}
        className={classes.createBox}
        justifyContent="center"
      >
        <Grid
          container
          alignContent="flex-start"
          justifyContent="center"
          style={{ position: "relative", width: "100%" }}
        >
          <IconButton
            aria-label="Fechar"
            className={classes.btnClose}
            onClick={onClose}
          >
            <Icon>add</Icon>
          </IconButton>
          <Grid
            container
            xs={12}
            spacing={3}
            justifyContent="center"
            className={classes.top}
          >
            <Grid container xs={9}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                <Link
                  color="inherit"
                  onClick={onClose}
                  style={{ cursor: "pointer" }}
                >
                  {"Meu Perfil"}
                </Link>
                <Typography color="textPrimary">
                  {"Cadastrar colaborador"}
                </Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
          <Grid container xs={6}>
            <form noValidate autoComplete="off" className={classes.form}>
              <TextField
                id="name"
                name="name"
                label="Nome"
                fullWidth
                margin="dense"
                value={inputName}
                error={!validated.name.valid}
                helperText={validated.name.text}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <TextField
                id="cpf"
                name="cpf"
                label="CPF"
                fullWidth
                margin="dense"
                type="text"
                value={inputCpf}
                error={!validated.cpf.valid}
                helperText={validated.cpf.text}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <TextField
                id="email"
                name="email"
                label="E-mail"
                fullWidth
                margin="dense"
                type="email"
                value={inputEmail}
                error={!validated.email.valid}
                helperText={validated.email.text}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <Button
                variant="contained"
                color="primary"
                disableElevation
                className={classes.btnRegister}
                onClick={submitForm}
              >
                {"Cadastrar Colaborador"}
              </Button>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateEmployees;
